import React, { RefObject, useRef } from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import styles from "./UpButton.module.scss";

interface Props {
    scrollableRef?: RefObject<HTMLElement>;
}

export const UpButton: React.FC<Props> = ({ scrollableRef }) => {
    const buttonRef = useRef<HTMLButtonElement>(null);

    const scrollToTop = () => {
        if (scrollableRef && scrollableRef.current) {
            scrollableRef.current.scrollTo({ top: 0, behavior: "smooth" });
            return;
        }
        // No explicit ref: walk up to the layout scroll container (the only
        // element that scrolls — the document itself does not).
        const container = buttonRef.current?.closest(".contentScroll");
        if (container) {
            container.scrollTo({ top: 0, behavior: "smooth" });
        } else {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    return (
        <>
            <Button
                ref={buttonRef}
                onClick={scrollToTop}
                variant="secondary"
                className={styles.upButton}
                title="Scroll up"
            >
                <FontAwesomeIcon icon={faArrowUp} />
            </Button>
        </>
    );
};
